import { get, sortBy } from 'lodash/fp'
import { createSelector } from 'reselect'
import { Selector } from '../types/common'
import { RootState } from '../store'
import { IBranch, IDivision } from '../types/user'

export const managerBranchesSelector: Selector<IBranch[]> = createSelector(
  get('manager.branches'),
  (branches: IBranch[]) => sortBy(['name', 'id'], branches),
)
export const managerBranchSelector: Selector<IBranch | undefined> = (state) => {
  const branch = get('manager.branch', state)
  const branches = managerBranchesSelector(state)
  if (branch && branch.id === -1 && window.location.pathname !== '/orders')
    return branches[0]
  return branch
}
export const managerAccountBranchesSelector: Selector<IBranch[]> =
  createSelector(
    (state): IBranch[] =>
      get('auth.user.role', state) === 'internal'
        ? get('accounts.detailedAccount.branches', state)
        : get('manager.accountBranches', state),
    (branches: IBranch[]) => sortBy(['name', 'id'], branches),
  )
export const ALL_BRANCHES_OPTION: IBranch = { id: -1, name: 'All Branches' }

// Prepends the "All Branches" option only on /orders. Pathname is not in the store
// (no connected-react-router), so the caller passes it from a reactive source
// (useLocation). Memoized on (branches, pathname) so the array reference is stable
// between renders — otherwise useSelector warns about a new reference each call.
export const managerBranchesOptionsSelector = createSelector(
  [managerBranchesSelector, (state: RootState, pathname: string) => pathname],
  (branches, pathname): IBranch[] =>
    pathname === '/orders' ? [ALL_BRANCHES_OPTION, ...branches] : branches,
)

export const divisionsSelector: Selector<IDivision[]> = get(
  'divisions.divisions',
)
